import React, { createContext, PropsWithChildren, useCallback, useContext, useState } from 'react';

export type ModalAccessibilityContextType = {
    isModalOpen: boolean;
    registerModal: () => void;
    unregisterModal: () => void;
};

const defaultValue: ModalAccessibilityContextType = {
    isModalOpen: false,
    registerModal: () => {},
    unregisterModal: () => {}
};

export const ModalAccessibilityContext = createContext<ModalAccessibilityContextType>(defaultValue);

function ModalAccessibilityContextProvider(props: PropsWithChildren<object>) {
    const { children } = props;
    const [count, setCount] = useState<number>(0);

    const registerModal = useCallback(() => setCount(c => c + 1), []);
    const unregisterModal = useCallback(() => setCount(c => Math.max(0, c - 1)), []);

    return (
        <ModalAccessibilityContext.Provider value={{ isModalOpen: count > 0, registerModal, unregisterModal }}>
            {children}
        </ModalAccessibilityContext.Provider>
    );
}

export const ModalAccessibilityProvider = ModalAccessibilityContextProvider;

export function useModalAccessibility() {
    return useContext(ModalAccessibilityContext);
}
